import { GraphSchema } from '@camelot/server';

export interface BankAccount {
  id: string;
  currency: string;
  currentBalance: number;
  description: string;
  holderName: string;
}

export const bankAccountProps = new GraphSchema<BankAccount>([
  'id',
  'currency',
  'currentBalance',
  'description',
  'holderName',
]);
